import { Alert, Box, Paper } from '@mui/material'
import { DataGridPro } from '@mui/x-data-grid-pro'
import DashboardLayout from '../../components/DashboardLayout'
import useController from './useController'
import CustomToolbar from '@components/CustomToolbar'

/**
 * A page showing the user an overview of all users, allowing them to query the data as they see
 * fit and draw insights easily.
 * @returns A page component
 */
const UsersOverviewPage = () => {
    const {
        error,
        dismissError,
        columns,
        dataSource,
        filterModel,
        onFilterModelChange,
    } = useController()

    return (
        <DashboardLayout>
            <Paper
                style={{
                    textAlign: 'center',
                    minHeight: '50%',
                    padding: 0,
                }}
            >
                {/*
                 * Shown above the grid, not instead of it. Nearly every
                 * failure here is a filter the server would not accept, and
                 * replacing the page would take away the very filter they
                 * need to go and fix.
                 */}
                {error && (
                    <Alert
                        severity="error"
                        onClose={dismissError}
                        sx={{ textAlign: 'left' }}
                    >
                        {error}
                    </Alert>
                )}
                {/* DataGrid starts here: it must have a constraining height */}
                <Box sx={{ height: 'calc(100vh - 140px)', width: '100%' }}>
                    {/* <Box sx={{ height: '65vh', width: '100%' }}> */}
                    <DataGridPro
                        columns={columns}
                        pagination
                        paginationMode="server"
                        sortingMode="server"
                        filterMode="server"
                        pageSizeOptions={[10, 20, 50]}
                        disableRowSelectionOnClick
                        disableVirtualization
                        dataSource={dataSource.dataSource}
                        filterModel={filterModel}
                        onFilterModelChange={onFilterModelChange}
                        showToolbar
                        slots={{
                            toolbar: CustomToolbar,
                        }}
                        slotProps={{
                            toolbar: {
                                csvOptions: { disableToolbarButton: true }, // Disable the default export button
                                printOptions: { disableToolbarButton: true }, // Disable print button if needed
                                exporting: dataSource.exporting,
                                exportAllRows: dataSource.exportAllRows,
                                exportFilename: 'users',
                            },
                        }}
                        initialState={{
                            columns: {
                                columnVisibilityModel: {
                                    id: false,
                                    first_name: false,
                                    last_name: false,
                                },
                            },
                        }}
                        getRowId={(row) => row.id}
                    />
                </Box>
            </Paper>
        </DashboardLayout>
    )
}

export default UsersOverviewPage
